"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var SimulcastLayers_1 = require("../simulcastlayers/SimulcastLayers");

var SimulcastTransceiverController_1 = require("../transceivercontroller/SimulcastTransceiverController");

var Types_1 = require("../utils/Types");

var DefaultVideoCaptureAndEncodeParameter_1 = require("../videocaptureandencodeparameter/DefaultVideoCaptureAndEncodeParameter");

var BitrateParameters_1 = require("./BitrateParameters");
/**
 * [[DefaultSimulcastUplinkPolicy]] determines capture and encode
 *  parameters that reacts to estimated uplink bandwidth
 */


var DefaultSimulcastUplinkPolicy = /*#__PURE__*/function () {
  function DefaultSimulcastUplinkPolicy(selfAttendeeId, logger) {
    _classCallCheck(this, DefaultSimulcastUplinkPolicy);

    this.selfAttendeeId = selfAttendeeId;
    this.logger = logger;
    this.numSenders = 0; // Simulcast is disabled when there are only 2 or fewer attendees, because in that case the backend will forward REMBs from
    // receiver to sender. Therefore there is no need for simulcast based adaption.

    this.shouldDisableSimulcast = false;
    this.newQualityMap = new Map();
    this.currentQualityMap = new Map();
    this.newActiveStreams = 1
    /* kHiAndLow */
    ;
    this.currentActiveStreams = 1
    /* kHiAndLow */
    ;
    this.lastUplinkBandwidthKbps = DefaultSimulcastUplinkPolicy.defaultUplinkBandwidthKbps;
    this.startTimeMs = 0;
    this.lastUpdatedMs = Date.now();
    this.videoIndex = null;
    this.currLocalDescriptions = [];
    this.nextLocalDescriptions = [];
    this.observerQueue = new Set();
    this.optimalParameters = new DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, true);
    this.parametersInEffect = new DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, true);
    this.lastUplinkBandwidthKbps = DefaultSimulcastUplinkPolicy.defaultUplinkBandwidthKbps;
    this.currentQualityMap = this.fillEncodingParamWithBitrates([300, 0, 1200]);
    this.newQualityMap = this.fillEncodingParamWithBitrates([300, 0, 1200]);
  }

  _createClass(DefaultSimulcastUplinkPolicy, [{
    key: "updateConnectionMetric",
    value: function updateConnectionMetric(_ref) {
      var _this = this;

      var _ref$uplinkKbps = _ref.uplinkKbps,
          uplinkKbps = _ref$uplinkKbps === void 0 ? 0 : _ref$uplinkKbps;

      if (isNaN(uplinkKbps)) {
        return;
      } // Check if startup period in order to ignore estimate when video first enabled.
      // If only audio was active then the estimate will be very low


      if (this.startTimeMs === 0) {
        this.startTimeMs = Date.now();
      }

      if (Date.now() - this.startTimeMs < DefaultSimulcastUplinkPolicy.startupDurationMs) {
        this.lastUplinkBandwidthKbps = DefaultSimulcastUplinkPolicy.defaultUplinkBandwidthKbps;
      } else {
        this.lastUplinkBandwidthKbps = uplinkKbps;
      }

      this.logger.debug(function () {
        return "simulcast: uplink policy update metrics ".concat(_this.lastUplinkBandwidthKbps);
      });
      var holdTime = DefaultSimulcastUplinkPolicy.holdDownDurationMs;

      if (this.currentActiveStreams === 3
      /* kLow */
      ) {
        holdTime = DefaultSimulcastUplinkPolicy.holdDownDurationMs * 2;
      } else if (this.currentActiveStreams === 2
      /* kMidAndLow */
      && uplinkKbps <= DefaultSimulcastUplinkPolicy.kMidDisabledRate || this.currentActiveStreams === 1
      /* kHiAndLow */
      && uplinkKbps <= DefaultSimulcastUplinkPolicy.kHiDisabledRate) {
        holdTime = DefaultSimulcastUplinkPolicy.holdDownDurationMs / 2;
      }

      if (Date.now() < this.lastUpdatedMs + holdTime) {
        return;
      }

      this.newQualityMap = this.calculateEncodingParameters(false);
    }
  }, {
    key: "calculateEncodingParameters",
    value: function calculateEncodingParameters(numSendersChanged) {
      // bitrates parameter min is not used for now
      var newBitrates = [new BitrateParameters_1.default(), new BitrateParameters_1.default(), new BitrateParameters_1.default()];
      var hysteresisIncrease = 0,
          hysteresisDecrease = 0;

      if (this.currentActiveStreams === 0
      /* kHi */
      ) {
        // Don't trigger redetermination based on rate if only one simulcast stream
        hysteresisIncrease = this.lastUplinkBandwidthKbps + 1;
        hysteresisDecrease = 0;
      } else if (this.currentActiveStreams === 1
      /* kHiAndLow */
      ) {
        hysteresisIncrease = 2400;
        hysteresisDecrease = DefaultSimulcastUplinkPolicy.kHiDisabledRate;
      } else if (this.currentActiveStreams === 2
      /* kMidAndLow */
      ) {
        hysteresisIncrease = 1000;
        hysteresisDecrease = DefaultSimulcastUplinkPolicy.kMidDisabledRate;
      } else {
        hysteresisIncrease = 300;
        hysteresisDecrease = 0;
      }

      if (numSendersChanged || this.lastUplinkBandwidthKbps >= hysteresisIncrease || this.lastUplinkBandwidthKbps <= hysteresisDecrease) {
        if (this.shouldDisableSimulcast) {
          // See comment above `shouldDisableSimulcast` for usage.
          //
          // The value of `newActiveStreams` is somewhat irrelevant since this single
          // stream will adapt based on both sender and receiver network conditions.
          //
          // We use middle layer here to work around a bug in Chromium where
          // it seems when a transceiver is created when BWE is low (e.g. on a reconnection),
          // it will never reset the encoder even when `setParameters` is called.  WebRTC bug
          // #12788 seems to call a similar issue out as fixed for VP8, it's not clear if this
          // is the same issue for H.264. Additionally we are not able to force a keyframe
          // request from the backend since it will only be sending padding (which also
          // don't have MID due to #10822). Since we don't scale when simulcast is disabled
          // this doesn't have any end-user effect.
          //
          // Note that this still relies on a little bit (5-6 packets) of padding on reconnect
          // and that technically the browser will still eventually try to send all 3 streams.
          //
          // Also note that due to some uninvestigated logic in bitrate allocation, Chromium
          // will skip the bottom layer if we try setting it to 1200 kbps instead so it will still take a while to
          // recover (as it needs to send padding until it reaches around 1000 kbps).
          this.newActiveStreams = 0
          /* kHi */
          ;
          newBitrates[0].maxBitrateKbps = 0;
          newBitrates[1].maxBitrateKbps = 1200;
          newBitrates[2].maxBitrateKbps = 0;
        } else if (this.numSenders <= 4 && this.lastUplinkBandwidthKbps >= DefaultSimulcastUplinkPolicy.kHiDisabledRate) {
          // 320x192+ (640x384)  + 1280x768
          this.newActiveStreams = 1
          /* kHiAndLow */
          ;
          newBitrates[0].maxBitrateKbps = 300;
          newBitrates[1].maxBitrateKbps = 0;
          newBitrates[2].maxBitrateKbps = 1200;
        } else if (this.lastUplinkBandwidthKbps >= DefaultSimulcastUplinkPolicy.kMidDisabledRate) {
          // 320x192 + 640x384 + (1280x768)
          this.newActiveStreams = 2
          /* kMidAndLow */
          ;
          newBitrates[0].maxBitrateKbps = this.lastUplinkBandwidthKbps >= 350 ? 200 : 150;
          newBitrates[1].maxBitrateKbps = this.numSenders <= 6 ? 600 : 350;
          newBitrates[2].maxBitrateKbps = 0;
        } else {
          // 320x192 + 640x384 + (1280x768)
          this.newActiveStreams = 3
          /* kLow */
          ;
          newBitrates[0].maxBitrateKbps = 300;
          newBitrates[1].maxBitrateKbps = 0;
          newBitrates[2].maxBitrateKbps = 0;
        }

        var bitrates = newBitrates.map(function (v, _i, _a) {
          return v.maxBitrateKbps;
        });
        this.newQualityMap = this.fillEncodingParamWithBitrates(bitrates);

        if (!this.encodingParametersEqual()) {
          this.logger.info("simulcast: policy:calculateEncodingParameters bw:".concat(this.lastUplinkBandwidthKbps, " numSources:").concat(this.numSenders, " shouldDisableSimulcast:").concat(this.shouldDisableSimulcast, " newQualityMap: ").concat(this.getQualityMapString(this.newQualityMap)));
        }
      }

      return this.newQualityMap;
    }
  }, {
    key: "chooseMediaTrackConstraints",
    value: function chooseMediaTrackConstraints() {
      // Changing MediaTrackConstraints causes a restart of video input and possible small
      // scaling changes.  Always use 720p for now
      var trackConstraint = {
        width: {
          ideal: 1280
        },
        height: {
          ideal: 768
        },
        frameRate: {
          ideal: 15
        }
      };
      return trackConstraint;
    }
  }, {
    key: "chooseEncodingParameters",
    value: function chooseEncodingParameters() {
      this.currentQualityMap = this.newQualityMap;
      this.currentActiveStreams = this.newActiveStreams;

      if (this.activeStreamsToPublish !== this.newActiveStreams) {
        this.activeStreamsToPublish = this.newActiveStreams;
        this.publishEncodingSimulcastLayer();
      }

      return this.currentQualityMap;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      // the +1 for self is assuming that we intend to send video, since
      // the context here is VideoUplinkBandwidthPolicy
      var numSenders = videoIndex.numberOfVideoPublishingParticipantsExcludingSelf(this.selfAttendeeId) + 1;
      var numSendersChanged = numSenders !== this.numSenders; // See comment above `shouldDisableSimulcast`

      var numParticipants = videoIndex.numberOfParticipants();
      var newShouldDisableSimulcast = numParticipants >= 0 && numParticipants <= 2;
      var shouldDisableSimulcastChanged = this.shouldDisableSimulcast !== newShouldDisableSimulcast;
      this.numSenders = numSenders;
      this.shouldDisableSimulcast = newShouldDisableSimulcast;
      this.optimalParameters = new DefaultVideoCaptureAndEncodeParameter_1.default(this.captureWidth(), this.captureHeight(), this.captureFrameRate(), this.maxBandwidthKbps(), false);
      this.videoIndex = videoIndex;
      this.newQualityMap = this.calculateEncodingParameters(numSendersChanged || shouldDisableSimulcastChanged);
    }
  }, {
    key: "wantsResubscribe",
    value: function wantsResubscribe() {
      var _this2 = this;

      var constraintDiff = !this.encodingParametersEqual();
      this.nextLocalDescriptions = this.videoIndex.localStreamDescriptions();

      var _loop = function _loop(i) {
        var streamId = _this2.nextLocalDescriptions[i].streamId;

        if (streamId !== 0 && !!streamId) {
          var prevIndex = _this2.currLocalDescriptions.findIndex(function (val) {
            return val.streamId === streamId;
          });

          if (prevIndex !== -1) {
            if (_this2.nextLocalDescriptions[i].disabledByWebRTC !== _this2.currLocalDescriptions[prevIndex].disabledByWebRTC) {
              constraintDiff = true;
            }
          }
        }
      };

      for (var i = 0; i < this.nextLocalDescriptions.length; i++) {
        _loop(i);
      }

      if (constraintDiff) {
        this.lastUpdatedMs = Date.now();
      }

      this.currLocalDescriptions = this.nextLocalDescriptions;
      return constraintDiff;
    }
  }, {
    key: "compareEncodingParameter",
    value: function compareEncodingParameter(encoding1, encoding2) {
      return JSON.stringify(encoding1) === JSON.stringify(encoding2);
    }
  }, {
    key: "encodingParametersEqual",
    value: function encodingParametersEqual() {
      var different = false;

      var _iterator = _createForOfIteratorHelper(SimulcastTransceiverController_1.default.NAME_ARR_ASCENDING),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ridName = _step.value;
          different = different || !this.compareEncodingParameter(this.newQualityMap.get(ridName), this.currentQualityMap.get(ridName));

          if (different) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return !different;
    }
  }, {
    key: "chooseCaptureAndEncodeParameters",
    value: function chooseCaptureAndEncodeParameters() {
      // should deprecate in this policy
      this.parametersInEffect = this.optimalParameters.clone();
      return this.parametersInEffect.clone();
    }
  }, {
    key: "captureWidth",
    value: function captureWidth() {
      // should deprecate in this policy
      var width = 1280;
      return width;
    }
  }, {
    key: "captureHeight",
    value: function captureHeight() {
      // should deprecate in this policy
      var height = 768;
      return height;
    }
  }, {
    key: "captureFrameRate",
    value: function captureFrameRate() {
      // should deprecate in this policy
      return 15;
    }
  }, {
    key: "maxBandwidthKbps",
    value: function maxBandwidthKbps() {
      // should deprecate in this policy
      return 1400;
    }
  }, {
    key: "setIdealMaxBandwidthKbps",
    value: function setIdealMaxBandwidthKbps(_idealMaxBandwidthKbps) {// should deprecate in this policy
    }
  }, {
    key: "setHasBandwidthPriority",
    value: function setHasBandwidthPriority(_hasBandwidthPriority) {// should deprecate in this policy
    }
  }, {
    key: "fillEncodingParamWithBitrates",
    value: function fillEncodingParamWithBitrates(bitratesKbps) {
      var newMap = new Map();
      var toBps = 1000;
      var nameArr = SimulcastTransceiverController_1.default.NAME_ARR_ASCENDING;
      var bitrateArr = bitratesKbps; // Don't scale the single simulcast stream regardless of its layer.

      var scale = this.shouldDisableSimulcast ? 1 : 4;

      for (var i = 0; i < nameArr.length; i++) {
        var ridName = nameArr[i];
        newMap.set(ridName, {
          rid: ridName,
          active: bitrateArr[i] > 0 ? true : false,
          scaleResolutionDownBy: Math.max(scale, 1),
          maxBitrate: bitrateArr[i] * toBps
        });
        scale = scale / 2;
      }

      return newMap;
    }
  }, {
    key: "getQualityMapString",
    value: function getQualityMapString(params) {
      var qualityString = '';
      var localDescriptions = this.videoIndex.localStreamDescriptions();

      if (localDescriptions.length === 3) {
        params.forEach(function (value) {
          var disabledByWebRTC = false;
          if (value.rid === 'low') disabledByWebRTC = localDescriptions[0].disabledByWebRTC;else if (value.rid === 'mid') disabledByWebRTC = localDescriptions[1].disabledByWebRTC;else disabledByWebRTC = localDescriptions[2].disabledByWebRTC;
          qualityString += "{ rid: ".concat(value.rid, " active:").concat(value.active, " disabledByWebRTC: ").concat(disabledByWebRTC, " maxBitrate:").concat(value.maxBitrate, "}");
        });
      }

      return qualityString;
    }
  }, {
    key: "getEncodingSimulcastLayer",
    value: function getEncodingSimulcastLayer(activeStreams) {
      switch (activeStreams) {
        case 0
        /* kHi */
        :
          return SimulcastLayers_1.default.High;

        case 1
        /* kHiAndLow */
        :
          return SimulcastLayers_1.default.LowAndHigh;

        case 2
        /* kMidAndLow */
        :
          return SimulcastLayers_1.default.LowAndMedium;

        case 3
        /* kLow */
        :
          return SimulcastLayers_1.default.Low;
      }
    }
  }, {
    key: "publishEncodingSimulcastLayer",
    value: function publishEncodingSimulcastLayer() {
      var simulcastLayers = this.getEncodingSimulcastLayer(this.activeStreamsToPublish);
      this.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.encodingSimulcastLayersDidChange).map(function (f) {
          return f.bind(observer)(simulcastLayers);
        });
      });
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.logger.info('adding simulcast uplink observer');
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.logger.info('removing simulcast uplink observer');
      this.observerQueue.delete(observer);
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _this3 = this;

      var _iterator2 = _createForOfIteratorHelper(this.observerQueue),
          _step2;

      try {
        var _loop2 = function _loop2() {
          var observer = _step2.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this3.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return DefaultSimulcastUplinkPolicy;
}();

exports.default = DefaultSimulcastUplinkPolicy;
DefaultSimulcastUplinkPolicy.defaultUplinkBandwidthKbps = 1200;
DefaultSimulcastUplinkPolicy.startupDurationMs = 6000;
DefaultSimulcastUplinkPolicy.holdDownDurationMs = 4000;
DefaultSimulcastUplinkPolicy.defaultMaxFrameRate = 15; // Current rough estimates where webrtc disables streams

DefaultSimulcastUplinkPolicy.kHiDisabledRate = 700;
DefaultSimulcastUplinkPolicy.kMidDisabledRate = 240;